<div class="rg-page-header">
  <div>
    <h3 class="fw-bold mb-1">Audit Logs</h3>
    <p class="text-muted mb-0">
      Track admin actions across organizations, licences, credentials and users.
    </p>
  </div>

  <button class="btn btn-outline-secondary" (click)="loadLogs()" [disabled]="loading">
    <i class="bi bi-arrow-clockwise me-1"></i>
    Refresh
  </button>
</div>

<div class="container-fluid p-4">
  <div class="card border-0 shadow-sm rg-card">
    <div class="card-body">
      <div class="row g-2 align-items-end mb-3">
        <div class="col-12 col-lg-3">
          <label class="form-label">Search</label>
          <input
            type="text"
            class="form-control"
            placeholder="Admin email, description..."
            [(ngModel)]="search"
            (keyup.enter)="applyFilters()">
        </div>

        <div class="col-12 col-lg-3">
          <label class="form-label">Entity Name</label>
          <input
            type="text"
            class="form-control"
            placeholder="Organization, AdminUser..."
            [(ngModel)]="entityName">
        </div>

        <div class="col-12 col-lg-3">
          <label class="form-label">Entity ID</label>
          <input
            type="text"
            class="form-control"
            placeholder="Optional entity id"
            [(ngModel)]="entityId">
        </div>

        <div class="col-12 col-lg-3">
          <label class="form-label">Admin User ID</label>
          <input
            type="text"
            class="form-control"
            placeholder="Optional admin id"
            [(ngModel)]="adminUserId">
        </div>

        <div class="col-12 d-flex gap-2">
          <button class="btn btn-outline-primary" (click)="applyFilters()">
            <i class="bi bi-funnel me-1"></i>
            Filter
          </button>

          <button class="btn btn-outline-secondary" (click)="clearFilters()">
            Clear
          </button>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table align-middle mb-0">
          <thead>
            <tr>
              <th>Action</th>
              <th>Admin</th>
              <th>Entity</th>
              <th>Description</th>
              <th>IP Address</th>
              <th>Created</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngIf="!loading && logs.length === 0">
              <td colspan="6" class="text-center py-4 text-muted">
                No record found.
              </td>
            </tr>

            <tr *ngFor="let log of logs">
              <td>
                <span class="badge" [ngClass]="getActionClass(log.actionType)">
                  {{ getActionLabel(log.actionType) }}
                </span>
              </td>

              <td>
                <div class="fw-semibold">{{ log.adminEmail || 'System' }}</div>
                <small class="text-muted">{{ log.adminUserId || '—' }}</small>
              </td>

              <td>
                <div class="fw-semibold">{{ log.entityName }}</div>
                <small class="text-muted">{{ log.entityId || '—' }}</small>
              </td>

              <td>{{ log.description }}</td>

              <td>{{ log.ipAddress || '—' }}</td>

              <td>{{ log.createdAt | date:'medium' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-between align-items-center mt-3">
        <small class="text-muted">
          Page {{ meta.page }} of {{ meta.totalPages || 1 }}
          — {{ meta.totalItems }} item(s)
        </small>

        <div class="btn-group">
          <button
            class="btn btn-outline-secondary btn-sm"
            [disabled]="page <= 1 || loading"
            (click)="previousPage()">
            Previous
          </button>

          <button
            class="btn btn-outline-secondary btn-sm"
            [disabled]="page >= meta.totalPages || loading"
            (click)="nextPage()">
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
